// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__mvBpJ","header":"Messages_header__fMvO4"};